var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.profile)?_c('img',{staticClass:"profile circle",attrs:{"src":_vm.profile}}):_c('div',{staticClass:"profile-no-image",style:(("background-color:" + _vm.backgroundColor + ";"))},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }